export default { MORTGAGE_STATUS_CLICKED: 'Mortgage Status Clicked' };
